/* Team Members Alt Block JS File */
$(document).ready(function() {
	if ($(".team-members-alt-wrapper").length > 0) {
		$(document).on('click', '.team-members-alt-wrapper .team-member-popup-button-trigger', function() {
			const teamId = $(this).attr('data-id');
			$.magnificPopup.close();
			$.magnificPopup.open({
				type: 'ajax',
				items: {},
				mainClass: 'team-member-alt-popup fade-in',
				tLoading: coreData.loader,
				ajax: {
					settings: {
						type: "post",
						url: coreData.ajaxurl,
						data: {
							action: "team_member_alt_popup",
							teamId: teamId,
						},
					},
					cursor: 'mfp-ajax-cur',
					tError: '<a href="%url%">The content</a> could not be loaded.'
				},
				callbacks: {
					ajaxContentAdded: function() {

					}
				}
			});
		})
	}
});
